import React, { Component } from 'react';
import { connect } from 'react-redux';
import PubNub from 'pubnub';
import {
  Col,
  Layout,
  Row,
  Select,
  Spin,
  Button,
  notification,
  Typography,
} from 'antd';
import config from '../../../config';
import NewPendingOnboardingTable from './NewPendingOnboardingTable';
import OptionForm from '../../components/NewPendingOnboarding/OptionForm';
import CommentsDialog from '../../components/comments/CommentsDialog';
import { getAllOperators } from '../../services/api/pending-onboarding';
import { setOperators, setCommentOpened } from '../../actions';
import SuggestionsDialog from '../../components/suggestions/SuggestionsDialog';
import SubHeaderComponent from '../../components/SubHeaderComponent';
import HeaderComponent from '../../components/HeaderComponent';
import { fetchCenters, fetchDoctors } from '../../services';
import { debounce } from '../../utils';
import SidebarComponent from '../../components/sidebarComponent';

const { Option } = Select;
const { Text } = Typography;

class NewPendingOnboardingHome extends Component {
  constructor(props) {
    super(props);
    this.state = {
      appBarTitle: 'Doctor Registration Form',
      doctorId: null,
      docData: null,
      open: false,
      ncIdForEdit: null,
      openRegisterNetworkCenter: false,
      openChat: false,
      selectedRequestId: null,
      pendingOnboardings: [],
      requestId: null,
      showSuggestions: false,
      fetchingDoctors: false,
      fetchedDoctors: [],
      fetchingCenters: false,
      isSidebarOpen: true,
      fetchedCenters: [],
    };
    if (!props.authToken) {
      props.history.push('/');
    }
    // this.debouncedFetchHealthCenters = debounce(this.onSearchCenter, 600);
    // this.debouncedFetchDoctors = debounce(this.onSearchDoctor, 600);
    // this.pubnubClient = new PubNub({
    //   subscribeKey: config.pubnubSubscribeKey,
    //   publishKey: config.pubnubPublishKey,
    // });
  }

  // componentDidMount() {
  //   const { dispatch } = this.props;
  //   this.fetchAllOperators();
  //   this.pubnubClient.subscribe({
  //     channels: [config.notificationChannel],
  //     withPresence: false,
  //   });
  //   this.pubnubClient.addListener({
  //     message: msg => {
  //       console.log(msg, 'Incoming message');
  //       // check for incoming message and update the status
  //       if (msg.message) {
  //         const messagePayload = msg.message;
  //         // update the state
  //         notification.info({
  //           key: msg.timetoken,
  //           message: `${messagePayload.name}: ${messagePayload.text}`,
  //           onClick: () => {
  //             if (messagePayload.requestId) {
  //               dispatch(
  //                 setCommentOpened({
  //                   requestId: messagePayload.requestId,
  //                 })
  //               );
  //             }
  //           },
  //           duration: 4,
  //         });
  //       }
  //     },
  //   });
  // }

  // componentDidUpdate(prevProps, prevState) {
  //   this.pubnubClient.unsubscribeAll();
  // }

  // fetchAllOperators = () => {
  //   const dispatch = this.props.dispatch;
  //   getAllOperators()
  //     .then(resp => {
  //       if (resp.message === 'success') {
  //         let currentOperator;
  //         if (this.props.user.userId) {
  //           currentOperator = resp.operators.find(
  //             o => o.operatorId === this.props.user.userId
  //           );
  //         }
  //         dispatch(
  //           setOperators({
  //             operators: resp.operators,
  //             currentOperator,
  //             sponsors: resp.sponsors,
  //             verticals: resp.verticals,
  //           })
  //         );
  //       }
  //     })
  //     .catch(err => {
  //       console.log(err);
  //     });
  // };

  // getRequestIdFromNotificationPanel = requestId => {
  //   this.setState({
  //     selectedRequestId: requestId,
  //     openChat: true,
  //   });
  // };

  // openSuggestions = () => {
  //   console.log('Open Suggestions');
  //   this.setState({
  //     showSuggestions: true,
  //   });
  // };

  // closeSuggestions = () => {
  //   console.log('Close Suggestions');
  //   this.setState({
  //     showSuggestions: false,
  //   });
  // };

  // onSearchDoctor = value => {
  //   this.setState({ fetchingDoctors: true });
  //   if (value.trim() === '') {
  //     this.setState({
  //       fetchedDoctors: [],
  //       fetchingDoctors: false,
  //     });
  //     return;
  //   }
  //   fetchDoctors(value)
  //     .then(res => {
  //       this.setState({
  //         fetchedDoctors: res.result.map(ele => ({
  //           key: ele.doctorId,
  //           label: `${ele.doctorName}-${ele.verticalName}`,
  //           ...ele,
  //         })),
  //       });
  //     })
  //     .finally(() => {
  //       this.setState({
  //         fetchingDoctors: false,
  //       });
  //     });
  // };

  // onSearchCenter = value => {
  //   this.setState({ fetchingCenters: true });
  //   if (value.trim() === '') {
  //     this.setState({
  //       fetchedCenters: [],
  //       fetchingCenters: false,
  //     });
  //     return;
  //   }
  //   fetchCenters(value)
  //     .then(res => {
  //       this.setState({
  //         fetchedCenters: res.result.map(ele => ({
  //           key: ele.centerId,
  //           label: ele.title,
  //           locality: ele.locality,
  //         })),
  //       });
  //     })
  //     .finally(() => {
  //       this.setState({
  //         fetchingCenters: false,
  //       });
  //     });
  // };
  toggleSidebar = () => {
    this.setState({
      isSidebarOpen: !this.state.isSidebarOpen,
    });
  }


  render() {
    const {
      fetchingDoctors,
      fetchedDoctors,
      fetchingCenters,
      fetchedCenters,
      isSidebarOpen
    } = this.state;
    const { history } = this.props;
    return (
      <Layout>
        <div>
          <HeaderComponent />
          <div style={{
            display: 'flex',
          }}>
            <div style={{ zIndex: 1000 }}>

              <SidebarComponent isSidebarOpen={isSidebarOpen} toggleSidebar={this.toggleSidebar}/>
            </div>
            <div
              style={{ overflow: 'scroll' }}>
        {/* <MainAppBar
          getRequestIdFromNotificationPanel={
            this.getRequestIdFromNotificationPanel
          }
        /> */}
        <Layout>
          {/* <Row>
            <Col xs={24} md={{ span: 12, offset: 6 }}>
              <OptionForm />
            </Col>
          </Row> */}
          {/* <SubHeaderComponent/> */}
          {/* <Row
            gutter={[16, 16]}
            style={{ marginTop: '8px', textAlign: 'center' }}
          >
            <Col xs={24} md={{ span: 12, offset: 6 }}>
              <Row gutter={[16, 16]}>
                <Col span={8}>
                  <Button
                    onClick={this.openSuggestions}
                    style={{ alignSelf: 'center' }}
                  >
                    Suggestions
                  </Button>
                </Col>
                <Col span={8}>
                  <Select
                    showSearch
                    style={{ width: '100%' }}
                    dropdownMatchSelectWidth={false}
                    notFoundContent={
                      fetchingDoctors ? <Spin size="small" /> : null
                    }
                    defaultActiveFirstOption={false}
                    showArrow={false}
                    filterOption={false}
                    placeholder="Search for Doctors"
                    onSearch={this.debouncedFetchDoctors}
                    onChange={e => {
                      // Navigate to doctor profile page
                      console.log(e);
                      history.push(`/doctor-profile/${e}`);
                    }}
                  >
                    {fetchedDoctors.map(d => (
                      <Option key={d.key}>
                        <Row>{d.label}</Row>
                        <Row>
                          {d.centers.map(center => (
                            <Col>
                              <Text
                                code
                              >{`${center.hospitalName}, ${center.locality}`}</Text>
                              <Text code>
                                Is Active - {center.isActive ? 'Yes' : 'No'}
                              </Text>
                              <Text code>Status - {center.status}</Text>
                            </Col>
                          ))}
                        </Row>
                      </Option>
                    ))}
                  </Select>
                </Col>
                <Col span={8}>
                  <Select
                    showSearch
                    style={{ width: '100%' }}
                    dropdownMatchSelectWidth={false}
                    notFoundContent={
                      fetchingCenters ? <Spin size="small" /> : null
                    }
                    defaultActiveFirstOption={false}
                    showArrow={false}
                    filterOption={false}
                    placeholder="Search for Clinics/Hospitals"
                    onSearch={this.debouncedFetchHealthCenters}
                    onChange={e => {
                      // Navigate to doctor profile page
                      console.log(e);
                      history.push(`/center-profile/${e}`);
                    }}
                  >
                    {fetchedCenters.map(d => (
                      <Option key={d.key}>
                        <Col>
                          {d.label}({d.locality}){' '}
                          <Text code>
                            Is Active - {d.isActive ? 'Yes' : 'No'}
                          </Text>
                        </Col>
                      </Option>
                    ))}
                  </Select>
                </Col>
              </Row>
            </Col>
          </Row>

          <SuggestionsDialog
            isOpen={this.state.showSuggestions}
            closeSuggestions={this.closeSuggestions}
            verticals={this.props.verticals}
          /> */}
          <NewPendingOnboardingTable />
          {this.props.comments.requestId && <CommentsDialog />}
        </Layout>
        </div></div></div>
      </Layout>
    );
  }
}

function mapStateToProps(state) {
  return {
    comments: state.comments,
    user: state.user,
    verticals: state.info.verticals,
    authToken: state.user.authToken,
  };
}

export default connect(mapStateToProps)(NewPendingOnboardingHome);
